import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { TotalTimeSheetGeneralVM, TotalTimeSheetAll, TotalTimeSheetAllEmployees, TotalTimeSheetHoursEmployeeCount } from '../../interfaces/interfaces';
import { AuthService } from 'src/app/services/auth.service';
import { MaintainWatchComponent } from '../maintain-watch/maintain-watch.component';
import { map, Observable, take } from 'rxjs';
import { AddEvent, DataStateChangeEvent, GridComponent, GridDataResult, RowClassArgs } from '@progress/kendo-angular-grid';
import { State, process, CompositeFilterDescriptor, filterBy, AggregateDescriptor, GroupDescriptor, GroupResult, aggregateBy } from "@progress/kendo-data-query";
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from 'src/app/user.service';
import { CreamsSalesDashClass } from '../creams-dash/creamsSalesDash';
import { groupBy } from "@progress/kendo-data-query";

interface Model {
  product: string;
  sales: number;
}

@Component({
  selector: 'sdc-timesheet-dash',
  templateUrl: './timesheet-dash.component.html',
  styleUrls: ['./timesheet-dash.component.scss']
})
export class TimeSheetDashComponent implements OnInit {

  dateForm: UntypedFormGroup;
  dateTo: UntypedFormGroup;
  userName: string;
  role: string;
  isLoading = false;
  canEdit = false;

  day: string;
  month: string;
  year: string;


  //public gridData: SalesByYearVm[]; // | GroupResult[]; // Observable<any>;
  
  public filter: CompositeFilterDescriptor = {
    logic: "and",
    filters: [],
  };
  public isNew: boolean;
  public timesheets: TotalTimeSheetGeneralVM;

  

  constructor(
    private authService: AuthService,
    private formBuilder: UntypedFormBuilder,
  ) { }

  public gridStateAll: State = {
    sort: [],
    skip: 0,
    take: 100,
  };
  public gridStateAllEmployees: State = {
    sort: [],
    skip: 0,
    take: 100,
  };
  public gridStateHours: State = {
    sort: [],
    skip: 0,
    take: 100,
  };

  totalTimeSheetAll: TotalTimeSheetAll[] = [];
  totalTimeSheetAllEmployees: TotalTimeSheetAllEmployees[] = [];
  totalTimeSheetHours: TotalTimeSheetHoursEmployeeCount[] = [];

  public gridDataAll: any = process(this.totalTimeSheetAll, this.gridStateAll);
  public gridDataAllEmployees: any = process(this.totalTimeSheetAllEmployees, this.gridStateAllEmployees);
  public gridDataHours: any = process(this.totalTimeSheetHours, this.gridStateHours);

  ngOnInit(): void {
    this.canEdit = true;
    this.userName = localStorage.getItem('currentUserName');
    this.dateForm = this.formBuilder.group({
      getDateFrom: [null],
      getDateTo: [null],
    },);
    this.intialiseData();
  }

  intialiseData(): void {

    this.loadCreamsSales();
    
  }

  public rowCallback = (context: RowClassArgs) => {
    if (context.dataItem.dayOfWeek == 'Sunday') {
      return { gold: true };
    } else {
      return { green: true };
    }
  };

  private loadCreamsSales(): void {

    this.authService.getTimeSheetDash({useDay: 0}).pipe(take(1)).subscribe({
      next: (response: TotalTimeSheetGeneralVM) => {

        this.timesheets = response;

        this.gridDataAll = process(this.timesheets.totalTimeSheetAll, this.gridStateAll);

        this.gridDataAllEmployees = process(this.timesheets.totalTimeSheetAllEmployees, this.gridStateAllEmployees);

        this.gridDataHours = process(this.timesheets.totalTimeSheetHoursEmployeeCount, this.gridStateHours);
        //alert(this.total);
        //this.sales = this.sales.
        this.isLoading = false;
      },
      error: (error: HttpErrorResponse) => {
        //alert(error);
        this.isLoading = false;
      }
    });

  }

  getDay(): void {
    
    //alert("In GetDay " + this.dateForm.controls.getDateFrom.value + ' ' + this.dateForm.controls.getDateFrom.value);

    this.authService.getTimeSheetDash({day: this.dateForm.controls.getDateFrom.value, dayTo: this.dateForm.controls.getDateTo.value}).pipe(take(1)).subscribe({
      next: (response: TotalTimeSheetGeneralVM) => {

        //alert("In Next");
        this.timesheets = response;

        this.gridDataAll = process(this.timesheets.totalTimeSheetAll, this.gridDataAll);

        this.gridDataAllEmployees = process(this.timesheets.totalTimeSheetAllEmployees, this.gridDataAllEmployees);

        this.gridDataHours = process(this.timesheets.totalTimeSheetHoursEmployeeCount, this.gridStateHours);

        this.isLoading = false;
      },
      error: (error: HttpErrorResponse) => {
        //alert(error);
        this.isLoading = false;
      }
    });
  }

}
